import { CircularProgress, Tooltip } from '@mui/material';
import classnames from 'classnames';
import { AsyncTransformControl } from 'js/components/recipeBuilder/AsyncTransformControl/AsyncTransformControl';
import { NexsetRulesIcon } from 'js/components/recipeBuilder/icons/NexsetRulesIcon';
import { Button } from 'new/elements/Button';
import { Stack } from 'new/elements/Stack';
import React from 'react';

export default function ConfigureRecipeHeader({
  showAsyncControl = true,
  isRecipeUnapplied,
  isLoading,
  onApplyRecipeClicked,
}: {
  showAsyncControl?: boolean;
  isLoading: boolean;
  isRecipeUnapplied: boolean;
  onApplyRecipeClicked: () => void;
}) {
  return (
    <div className="recipe-samples-header">
      <div className="recipe-samples-header-left-content recipe-samples-header-center-content">
        <Stack direction="row" alignItems="center">
          <NexsetRulesIcon />
          <span className="recipe-samples-header-text">Nexset Rules</span>
        </Stack>
        {showAsyncControl && <AsyncTransformControl />}
      </div>
      <Tooltip
        title={
          <div style={{ textAlign: 'center' }}>
            <div>Test and Apply Rules</div>
            <div style={{ fontSize: '11px', opacity: 0.8, marginTop: 'var(--spacing-sm)' }}>
              {navigator.platform.includes('Mac') ? '⌘ + Enter' : 'Ctrl + Enter'}
            </div>
          </div>
        }
        placement="bottom"
        arrow
      >
        <span>
          <Button
            variant="outlined"
            color="secondary"
            className={classnames('transform-apply-cta', {
              highlighted: isRecipeUnapplied,
            })}
            disabled={isLoading}
            onClick={onApplyRecipeClicked}
          >
            {isLoading ? (
              <CircularProgress color="inherit" size={14} thickness={6} />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M13.6627 5.31175L7.30267 0.645086C6.80593 0.281343 6.21815 0.062282 5.60451 0.0121947C4.99087 -0.0378927 4.37535 0.0829503 3.8262 0.361324C3.27704 0.639698 2.81572 1.06472 2.49337 1.58928C2.17103 2.11383 2.00026 2.71741 2 3.33309V12.6664C2.00011 13.2824 2.17089 13.8863 2.49338 14.411C2.81588 14.9358 3.27748 15.361 3.82695 15.6394C4.37642 15.9177 4.99227 16.0384 5.60616 15.988C6.22006 15.9376 6.80797 15.718 7.30467 15.3538L13.6647 10.6871C14.0868 10.3775 14.4302 9.97279 14.6668 9.50579C14.9034 9.03879 15.0268 8.52262 15.0268 7.99909C15.0268 7.47555 14.9034 6.95938 14.6668 6.49238C14.4302 6.02538 14.0868 5.62069 13.6647 5.31109L13.6627 5.31175ZM12.8733 9.61175L6.51333 14.2784C6.21534 14.4962 5.86291 14.6272 5.49505 14.6571C5.12718 14.6869 4.75824 14.6144 4.42904 14.4475C4.09985 14.2806 3.82326 14.0259 3.62987 13.7116C3.43648 13.3972 3.33385 13.0355 3.33333 12.6664V3.33309C3.32963 2.96332 3.43033 2.60001 3.62385 2.2849C3.81737 1.9698 4.09587 1.71568 4.42733 1.55175C4.70926 1.40835 5.02103 1.33343 5.33733 1.33309C5.76126 1.3347 6.17348 1.47234 6.51333 1.72575L12.8733 6.39242C13.1263 6.57822 13.332 6.82096 13.4738 7.101C13.6156 7.38104 13.6895 7.69053 13.6895 8.00442C13.6895 8.31831 13.6156 8.6278 13.4738 8.90784C13.332 9.18788 13.1263 9.43062 12.8733 9.61642V9.61175Z"
                  fill="#DB5327"
                />
              </svg>
            )}
            <div className="transform-apply-cta-text">Run Nexset Rules</div>
            {isRecipeUnapplied && <div className="transform-apply-animated-circle" />}
          </Button>
        </span>
      </Tooltip>
    </div>
  );
}
